import _ from 'lodash';
import SgSessionStorageService from '../sg-session-storage';

let hasUsedTouchDevice = false;

const setKeyboardNavigation = (event) => {
    if (event.keyCode === 9 && !hasUsedTouchDevice) {
        SgSessionStorageService.setItem(SgSessionStorageService.KEY.ACCESSIBILITY_NAVIGATION, true);
        document.removeEventListener('keydown', setKeyboardNavigation);
    }
};

const setTouchNavigation = () => {
    if ('ontouchstart' in document.documentElement) {
        hasUsedTouchDevice = true;
        SgSessionStorageService.setItem(SgSessionStorageService.KEY.ACCESSIBILITY_NAVIGATION, false);
        document.removeEventListener('touchstart', setTouchNavigation);
    }
};

const init = () => {
    document.addEventListener('keydown', setKeyboardNavigation);
    document.addEventListener('touchstart', setTouchNavigation);
};

const isAccessibilityNavigation = () => {
    return SgSessionStorageService.getItem(SgSessionStorageService.KEY.ACCESSIBILITY_NAVIGATION) === 'true';
};

const getFirstFocusableElementQuery = (page, isCEP) => {
    if (isCEP) {
        return 'input, select, a, button';
    }
    switch (page) {
        case '/journey/vehicle':
        case '/journey/drivers':
        case '/journey/summaryofdrivers':
        case '/journey/property':
        case '/journey/details':
        case '/journey/specifiedItems':
        case '/journey/aboutYou':
        case '/journey/your-details':
        case '/journey/your-property':
        case '/journey/your-cover':
        case '/journey/your-vehicle':
        case '/journey/enhance-your-cover':
            return 'input, select, a, button';
        default:
            return '*';
    }
};

const focusOnOriginalQuestion = (ids) => {
    setTimeout(() => {
        let element;
        _.each(ids, (id) => {
            const elementPresentInDOM = document.getElementById(id);
            if (elementPresentInDOM) {
                element = elementPresentInDOM;
            }
        });
        if (element) {
            const focusableElements = _.filter(element.querySelectorAll('input, select, a, button'),
                (elem) => elem.offsetHeight !== 0 && elem.offsetWidth !== 0);
            focusableElements[0].focus();
        }
    }, 100);
};

export default {
    init,
    isAccessibilityNavigation,
    getFirstFocusableElementQuery,
    focusOnOriginalQuestion
};
